import { toastr } from 'react-redux-toastr';
import { getResponseType, WTSResponseType } from 'src/api/communicate/responseTypeUtils';
import { I18n } from 'src/translations/i18n';
import { AXIOS_CANCELLED_REQUEST_ERROR_CODE } from 'src/constants/common';
import Utils from 'src/utils';
const UNKNOWN_ERROR_TRANSLATED_MESSAGE = () => I18n.t('UnknownErrorTryLater');
const getWtsResponseErrorData = async (error) => {
    let responseData = error?.response?.data;
    if (responseData?.constructor?.name === 'Blob') {
        responseData = await Utils.objects.parseFromBlob(responseData);
    }
    return responseData;
};
export const getWtsResponseErrorText = async (error) => {
    try {
        const responseData = await getWtsResponseErrorData(error);
        if (typeof responseData?.Text === 'function') {
            const data = await responseData.Text();
            const errorObj = JSON.parse(data);
            return errorObj?.ResultMsg ?? errorObj;
        }
        else if (responseData?.ResultMsg) {
            return responseData.ResultMsg;
        }
        else if (error.message) {
            return error.message;
        }
        else {
            return UNKNOWN_ERROR_TRANSLATED_MESSAGE();
        }
    }
    catch (err) {
        return err.message || UNKNOWN_ERROR_TRANSLATED_MESSAGE();
    }
};
export const errorToMessage = (message, status) => {
    const statusString = status ? `STATUS: ${status}. \n` : '';
    const messageString = `ERROR: ${message}`;
    return `${statusString}${messageString}`;
};
const getWtsResponseError = async (error, additionalMessage, opts) => {
    const errorText = await getWtsResponseErrorText(error);
    const message = errorToMessage(errorText, error.status);
    toastr.error(message, additionalMessage, opts);
};
const getWtsResultError = (error, additionalMessage, opts) => {
    const errorList = error.response?.data?.Error?.Messages;
    if (!errorList?.length) {
        toastr.error(error.message || UNKNOWN_ERROR_TRANSLATED_MESSAGE(), additionalMessage, opts);
    }
    else {
        errorList.forEach(({ PropertyName, Text }) => {
            let errorTitle;
            const errorBody = Text || UNKNOWN_ERROR_TRANSLATED_MESSAGE();
            if (PropertyName) {
                errorTitle = I18n.t('ErrorInProperty', { prop: PropertyName });
            }
            else {
                errorTitle = I18n.t('Error');
            }
            toastr.error(errorTitle, errorBody, opts);
        });
    }
};
const getNewWtsResultError = (error, additionalMessage, opts) => {
    const errorList = error.response?.data?.Errors;
    if (!errorList?.length) {
        toastr.error(error.message || UNKNOWN_ERROR_TRANSLATED_MESSAGE(), additionalMessage, opts);
    }
    else {
        errorList.forEach(({ Field, Message }) => {
            let errorTitle;
            const errorBody = Message || UNKNOWN_ERROR_TRANSLATED_MESSAGE();
            if (Field) {
                errorTitle = I18n.t('ErrorInProperty', { prop: Field });
            }
            else {
                errorTitle = I18n.t('Error');
            }
            toastr.error(errorTitle, errorBody, opts);
        });
    }
};
export default (error, additionalMessage, opts) => {
    if (error.code === AXIOS_CANCELLED_REQUEST_ERROR_CODE)
        return;
    try {
        console.error(error);
        const errorResponseType = error.response?.data
            ? getResponseType(error.response.data)
            : WTSResponseType.Response;
        if (errorResponseType === WTSResponseType.Response) {
            getWtsResponseError(error, additionalMessage, opts);
        }
        else if (errorResponseType === WTSResponseType.Result) {
            getWtsResultError(error, additionalMessage, opts);
        }
        else if (errorResponseType === WTSResponseType.ResultV2) {
            getNewWtsResultError(error, additionalMessage, opts);
        }
        else {
            toastr.error(UNKNOWN_ERROR_TRANSLATED_MESSAGE(), additionalMessage, opts);
        }
    }
    catch (e) {
        console.error('Internal error:', e);
        toastr.error(UNKNOWN_ERROR_TRANSLATED_MESSAGE(), undefined);
    }
};
